export default "/images/mydev-hover-light.svg?c0e738e93aa20cdd00cd10b0df3aaf39";